// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"94":"89a4af0c","177":"72558813","459":"a1e6f30b","780":"22d11afa"}[chunkId] + ".css";
};